export default __webpack_public_path__ + "static/media/7.fa2aa65d.png";